import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import FlexicoHistoryComponent from './FlexicoHistoryComponent';

export default (props) => {
    return <FlexicoHistoryComponent location={props.location} />;
}
